import { Stack } from "@mantine/core"
import { useParams } from "react-router-dom"

import { SupplierMonitoringWrapper } from "~/pages/Brand/Suppliers/List/SupplierMonitoringWrapper.tsx"
import { SupplierProductionSitesWrapper } from "~/pages/Brand/Suppliers/List/SupplierProductionSites/SupplierProductionSitesWrapper.tsx"

export const SuppliersList = () => {
  const params = useParams()
  const activeTab = params.tab ?? "monitoring"

  return (
    <Stack>
      {activeTab === "monitoring" && (
        <SupplierMonitoringWrapper type="supplier" />
      )}
      {activeTab === "productionSites" && <SupplierProductionSitesWrapper />}
    </Stack>
  )
}
